module.exports = __webpack_public_path__ + "static/media/Hochzeitseinladung-2.9834cb48.png";